/**
 * Tabbed Card Nav
 */

// Vendors
import $ from 'jquery';

$('.tabbed-card-nav').each((index, element) => {
  $(element)
    .find('nav.tabs a')
    .each((i, tabLink) => {
      $(tabLink).on('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        var cardLink = tabLink.hash + '-card-1';
        $(tabLink)
          .addClass('active')
          .parent()
          .siblings('li')
          .find('a')
          .removeClass('active');
        $(tabLink.hash).addClass('show').siblings().removeClass('show');
        $(cardLink).addClass('show').siblings().removeClass('show');
        return false;
      });
    });
  $(element)
    .find('.card-navs a.link')
    .each((i, cardLink) => {
      $(cardLink).on('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        var mobileCardElem = cardLink.hash + '-mobile';
        $(cardLink)
          .addClass('active')
          .parent()
          .siblings()
          .each((i, cardNavItem) => {
            $(cardNavItem).find('a').removeClass('active');
          });
        $(cardLink.hash).addClass('show').siblings().removeClass('show');
        $(mobileCardElem)
          .addClass('show')
          .siblings('.mobile-content')
          .removeClass('show');
        return false;
      });
    });
    $(element)
    .find('.card-navs a.link-info')
    .each((i, cardLink) => {
      $(cardLink).on('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        var mobileCardInfoElem = cardLink.hash + '-mobile';
        $(cardLink)
          .addClass('active')
          .parent()
          .siblings()
          .each((i, cardNavItem) => {
            $(cardNavItem).find('a').removeClass('active');
          });
        $(cardLink.hash).addClass('show').siblings().removeClass('show');
        $(mobileCardInfoElem)
          .addClass('show-info')
          .siblings('.mobile-content')
          .removeClass('show-info');
        return false;
      });
    });
});
